import React from "react";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(6),
    marginTop: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  column: {
    borderBottom: "1px solid #c2c2c2",
    marginBottom: 64,
  },
  contents: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    width: "100%",
    marginBottom: 12,
  },
  body: {
    backgroundColor: "#ffffff",
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
    paddingLeft: theme.spacing(4.75),
    paddingRight: theme.spacing(4.75),
    border: "1px solid #e0ebff",
  },
  form: {
    marginTop: 12,
  },
  grap: {
    height: 300,
  },
  table: {
    "& table": {
      border: "1px solid black",
      borderCollapse: "collapse",
    },
    "& thead": {
      backgroundColor: "#9e9e9e",
      color: "#fff",
    },
    "& tbody": {
      backgroundColor: "#fff",
    },
    "& th": {
      border: "1px solid black",
      borderCollapse: "collapse",
    },
    "& td": {
      border: "1px solid black",
      textAlign: "center",
      padding: 10,

      borderCollapse: "collapse",
    },
  },
}));
const ManWomanTr = ({ totalData }) => {
  return (
    <>
      <td>남자</td>
      <td>여자</td>
    </>
  );
};
const ManWomanTrResult = ({ totalData, cancer = "폐암" }) => {
  return (
    <>
      <td>
        {cancer === "폐암" ? totalData.lungStat.man : totalData.prosStat.man}명
      </td>
      <td>
        {cancer === "폐암"
          ? totalData.lungStat.woman
          : totalData.prosStat.woman}
        명
      </td>
    </>
  );
};
const SmokeTrResult = ({ totalData, cancer = "폐암" }) => {
  return (
    <>
      <td>
        {cancer === "폐암"
          ? totalData.lungStat.smoke
          : totalData.prosStat.smoke}
        명
      </td>
      <td>
        {cancer === "폐암"
          ? totalData.lungStat.smokeNo
          : totalData.prosStat.smokeNo}
        명
      </td>
    </>
  );
};
const SmokeTr = () => {
  return (
    <>
      <td>흡연</td>
      <td>비흡연</td>
    </>
  );
};
const EvalTable = ({ totalData }) => {
  const classes = useStyles();
  return (
    <Box p={1} flexGrow={1} className={classes.table}>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <td colSpan="2"></td>
            <>
              {totalData.map((data, index) => (
                <td colSpan="2" key={data.name}>
                  {data.name}
                </td>
              ))}
            </>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan="2" rowSpan="4">
              폐암
            </td>
            <>
              {totalData.map((data, index) => (
                <ManWomanTr key={data.name} />
              ))}
            </>
          </tr>
          <tr>
            {totalData.map((data, index) => (
              <ManWomanTrResult
                key={data.name}
                totalData={data}
                cancer="폐암"
              />
            ))}
          </tr>
          <tr>
            {totalData.map((data, index) => (
              <SmokeTr key={data.name} />
            ))}
          </tr>
          <tr>
            {totalData.map((data, index) => (
              <SmokeTrResult key={data.name} totalData={data} cancer="폐암" />
            ))}
          </tr>

          <tr>
            <td colSpan="2" rowSpan="4">
              전립선암
            </td>
            <>
              {totalData.map((data, index) => (
                <ManWomanTr key={data.name} />
              ))}
            </>
          </tr>
          <tr>
            {totalData.map((data, index) => (
              <ManWomanTrResult
                key={data.name}
                totalData={data}
                cancer="전립선암"
              />
            ))}
          </tr>
          <tr>
            {totalData.map((data, index) => (
              <SmokeTr key={data.name} />
            ))}
          </tr>
          <tr>
            {totalData.map((data, index) => (
              <SmokeTrResult
                key={data.name}
                totalData={data}
                cancer="전립선암"
              />
            ))}
          </tr>
        </tbody>
      </table>
    </Box>
  );
};

export default EvalTable;
